// appIdentity — the app's canonical identity strings.
//
// Lives at the app-package level (not @bilda/core, which is pure
// domain). Two names, on purpose:
// - `appName` is what people see (titles, brand, file names, logs).
// - `codeName` is the internal, stable name the deployment depends on:
//   the env-var prefix (`BILDA_*`) and the session cookie. Changing it
//   breaks every secret and signs everyone out, so a rebrand touches
//   only `appName`.
export { appName, codeName };
const appName = "Mymer";
const codeName = "bilda";
//# sourceMappingURL=appIdentity.js.map